import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Subscription} from "rxjs";
import {AiBuilderService} from "../../../../../websites/website/ai-builder/service/ai-builder.service";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";
import {User} from "@sentry/browser";
import {BuilderHistoryService} from "../../../../builder-history.service";
import {BuilderStepsEnum} from "../../../../builder-tour.enum";
import {BuilderSectionsInteractionService} from "../../../../builder-sections-interaction.service";
import sitemapSteps from "./sitemap-steps.json";
import singlePageSitemapSteps from "./single-page-sitemap-steps.json";
import {BuilderGeneratedPageI, PageMetaI} from "../../../../builder-v2.interface";
import {SafeHtml} from "@angular/platform-browser";
import {TriggersService} from "../../../../services/triggers.service";
import {CommonBuilderDataService} from "../../../../services/common-builder-data.service";
import {Website} from "../../../../../websites/website/website";

@Component({
    selector: 'db-outline-sitemap',
    templateUrl: './outline-generation-sitemap.component.html',
    styleUrl: './outline-generation-sitemap.component.scss',
    standalone: false
})
export class OutlineGenerationSitemapComponent implements OnInit {
  @Input() popupMode: boolean;
  @Input() website: Website;
  @Input() user: User;
  @Input() uniqueId: string;
  @Input() tourStep: number;
  @Input() isMobile: boolean;
  @Input() prefilledAi: boolean;
  @Input() singlePage: boolean;
  @Input() disableDraggingEvents?: boolean = false;
  @Input() outline: BuilderGeneratedPageI;
  @Input() pageMetas: PageMetaI[];
  @Input() fontStyles: SafeHtml[] = [];
  @Output() onGenerate: EventEmitter<void> = new EventEmitter();
  @Output() openMagicLink: EventEmitter<boolean> = new EventEmitter<boolean>();

  loading: boolean = false;
  builderStep = BuilderStepsEnum;
  sitemapStep: string[] = sitemapSteps;
  startAnimations$ = this._triggerService.startSidebarAnimations;

  @Output() next = new EventEmitter<string>();
  @Output() back = new EventEmitter<void>();

  private _categoriesRequestSubscription: Subscription;
  showActionsLine: boolean;

  constructor(
    public builderHistoryService: BuilderHistoryService,
    public builderInteractionsService: BuilderSectionsInteractionService,
    private _builderService: AiBuilderService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _triggerService: TriggersService,
    private _builderCommonDataService: CommonBuilderDataService,
    private _cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    if (this.singlePage) {
      this.sitemapStep = singlePageSitemapSteps;
    }
  }

  onEvent({
            eventCategory,
            eventAction,
            eventLabel,
          }) {
    this.sendEvent(eventCategory, eventAction, eventLabel);
  }

  sendEvent(category: string, action: string, label: string): void {
    const analyticsData = {
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      uniqueId: this._builderCommonDataService.uniqueId,
      isMobile: this.isMobile
    };
    if (!this.user) {
      this._googleAnalyticsService.sendAnalyticsEventWithCoreWithoutUserData(analyticsData);
    } else {
      this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
    }
  }


}
